import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { interval, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { ToastService } from 'src/app/shared/services';
import { commonService } from 'src/app/shared/services/common.service';
import { TourService } from 'src/app/shared/services/tour.service';
import { MenuItem } from 'primeng/api';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { environment } from 'src/environments/environment.prod';
import { OrgPlanService } from 'src/app/shared/services/org-plan.service';

@Component({
  selector: 'app-view-job-post-details',
  templateUrl: './view-job-post-details.component.html',
  styleUrls: ['./view-job-post-details.component.css'],
})
export class ViewJobPostDetailsComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  jobId: any;
  jobDetails: any;
  loading = true;
  searchText: string = '';
  uploadDialogVisible: boolean = false;
  selectedFile: File | null = null;
  candidates: any[] = [];
  filteredCandidates: any[] = [];
  postExamStatuses: any[] = [];
  examDialogVisible: boolean = false;
  currentExamId: number | null = null;
  selectedCandidate: any = null;
  stepItems = [
    { label: 'Interview' },
    { label: 'Offer' },
    { label: 'Onboarding' },
  ];

  activeStep = 0;
  originalExamData: any;
  rankingLoading = false;
  onboardingSteps = [
    { label: 'Interview Details' },
    { label: 'Offer Details' },
    { label: 'Review & Send' },
    { label: 'Onboarding Details' },
  ];

  /**
   * Named indices for the wizard. The Review step was inserted between
   * Offer and Onboarding, which pushed Onboarding from 2 to 3 — every
   * place that used to compare against a bare number now goes through
   * these so a future reorder is one edit, not a hunt.
   */
  readonly STEP_INTERVIEW = 0;
  readonly STEP_OFFER = 1;
  readonly STEP_REVIEW = 2;
  readonly STEP_ONBOARDING = 3;
  currentOnboardingStep = 0;
  currentStep = 0;
  onboardingForm!: FormGroup;

  // ===================== SCHEDULE MANUAL INTERVIEW =====================
  manualScheduleForm!: FormGroup;
  manualScheduleDialogVisible: boolean = false;
  isManualScheduling: boolean = false;
  manualScheduleResult: any = null;

  /** GET /interview/manual-schedule/{candidate_id}/ is in flight. */
  manualScheduleLoading: boolean = false;

  /** The saved booking is open in the edit form. */
  isEditingSchedule: boolean = false;

  /** Non-404 failure while checking for an existing booking. */
  manualScheduleLoadError: string = '';

  meetingIdCopied: boolean = false;
  interviewResultOptions = [
    {
      label: 'Passed',
      value: 'Passed',
    },

    {
      label: 'Failed',
      value: 'Failed',
    },

    {
      label: 'Hold',
      value: 'Hold',
    },
  ];

  onboardingStatusOptions = [
    {
      label: 'Pending',
      value: 'Pending',
    },

    // {
    //   label: 'Onboarded',
    //   value: 'Onboarded',
    // },

    {
      label: 'Completed',
      value: 'Completed',
    },

    // {
    //   label: 'Rejected',
    //   value: 'Rejected',
    // },
  ];
  docsNotVerified: boolean = false;
  isSubmitLoading = false;
  isOnboardingUpdate: boolean = false;
  isNextStepLoading = false;
  isOfferUpdate: boolean = false;
  isRanked = false;
  rankingDialogVisible = false;
  scoreCircumference = 2 * Math.PI * 45;
  isRankingDone = false;
  pollingSubscription?: Subscription;

  recruiterStatusOptions = [
    // {
    //   label: 'Pending Review',
    //   value: 'pending',
    // },

    {
      label: 'In Progress',
      value: 'inprogress',
    },

    {
      label: 'Selected',
      value: 'selected',
    },

    {
      label: 'Rejected',
      value: 'rejected',
    },

    {
      label: 'On Hold',
      value: 'hold',
    },
  ];
  isGeneratingLink: boolean = false;

  openRankingDetails(candidate: any) {
    this.selectedCandidate = candidate;
    this.rankingDialogVisible = true;
  }

  roleName = '';

  selectedCandidateIds = new Set<number>();
  notifyingRecruiter = false;

  get selectedCandidatesCount(): number {
    return this.selectedCandidateIds.size;
  }

  get approvedCandidates(): any[] {
    return this.filteredCandidates.filter((c) => c.approved === true);
  }

  get isAllApprovedSelected(): boolean {
    const approved = this.approvedCandidates;
    return (
      approved.length > 0 &&
      approved.every((c) => this.selectedCandidateIds.has(c.id))
    );
  }

  first = 0;
  rows = 10;

  paginatedCandidates: any[] = [];

  // Bulk CV Upload & Selection State
  bulkUploadDialogVisible: boolean = false;
  loadingWalkinCVs: boolean = false;
  processingCVs: boolean = false;

  walkinCVList: any[] = [];
  selectedWalkinCVs: any[] = [];

  currentBatchId: string | null = null;
  batchStatusData: any = null;
  batchProgressPercent: number = 0;

  private batchPollInterval: any = null;

  /** Tabs: 0 = Applied Candidates, 1 = Walk-in CV Pool. */
  activeTabIndex = 0;

  /**
   * Attach-from-walk-in progress, shown as a banner on both tabs:
   *  running → CVs are being parsed / accounts created in the background
   *  done    → finished; candidates are now in Applied Candidates
   *  error   → the request (or tracking it) failed
   */
  attachState: 'idle' | 'running' | 'done' | 'error' = 'idle';
  attachTotal = 0;
  attachDone = 0;
  attachFailed = 0;
  attachMessage = '';
  private destroy$ = new Subject<void>();
  selectedFiles: File[] = [];
  uploading = false;
  fileError = '';

  // Fast lookup instead of find()
  private candidateMap = new Map<number, any>();

  /** True while the org is on its free trial — shown as a badge in the
   *  Manage Onboarding dialog (see organization_plan / OrgPlanService). */
  isFreeTierOrg = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commonService: commonService,
    private location: Location,
    private toaster: ToastService,
    private fb: FormBuilder,
    private tourService: TourService,
    private sanitizer: DomSanitizer,
    private orgPlanService: OrgPlanService,
  ) {}

  ngOnInit(): void {
    // this.startTour();
    // TOUR DISABLED - re-enable by uncommenting this block.
    // if (!this.tourService.hasSeenTour('viewDetails')) {
    // setTimeout(() => {
    // this.startTour();
    // }, 1000);
    // }
    this.orgPlanService.orgPlan$.subscribe((plan) => {
      this.isFreeTierOrg = plan?.free_tier === true;
    });
    this.jobId = this.route.snapshot.paramMap.get('id');
    this.onboardingForm = this.fb.group({
      interview_mode: [''],

      interviewer_name: ['', Validators.required],

      interview_date: [null, Validators.required],

      interview_result: ['', Validators.required],

      interview_feedback: [''],

      offer_rolled_out_date: [null, Validators.required],

      offer_amount: ['', Validators.required],

      offer_details: ['', Validators.required],

      is_accepted: [false],

      onboarding_date: [null, Validators.required],

      onboarding_status: ['Pending', Validators.required],

      additional_info: [''],
    });

    this.manualScheduleForm = this.fb.group({
      scheduled_date: [null, Validators.required],
      start_time: [null, Validators.required],
    });

    this.getJobDetails();
    this.getCandidates();
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    this.roleName = user?.role_name || '';
    this.fetchWalkinCVs();
  }

  get isRecruiter(): boolean {
    return this.roleName?.toUpperCase() === 'RECRUITER';
  }

  startTour() {
    // TOUR DISABLED - re-enable by uncommenting this block.
    // this.tourService.startViewDetailsTour();
  }

  onStepChange(event: any) {
    this.currentStep = event.index; // Update current step based on click
    console.log('Step changed to:', this.currentStep);
  }

  isInvalid(field: string): boolean {
    const control = this.onboardingForm.get(field);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  nextStep() {
    if (!this.validateCurrentStep()) return;

    const form = this.onboardingForm.value;

    // REVIEW — nothing of its own to persist. The offer fields were
    // already saved when Step 2's Next was pressed, and the send itself
    // runs from sendOffer(); this is just the move forward.
    if (this.currentOnboardingStep === this.STEP_REVIEW) {
      this.currentOnboardingStep++;
      return;
    }

    // STEP 1

    if (this.currentOnboardingStep === this.STEP_INTERVIEW) {
      const payload = {
        interview_date: this.formatDate(form.interview_date),

        interviewer_name: form.interviewer_name,

        interview_feedback: form.interview_feedback,

        interview_result: form.interview_result,

        attached_cv: this.selectedCandidate.id,
      };

      if (this.currentExamId) {
        this.commonService
          .patch(`/jobpost/post-exam-statuses/${this.currentExamId}/`, payload)

          .subscribe({
            next: () => {
              this.onboardingChanged = true;
              this.currentOnboardingStep++;
            },
            error: (err) => this.handleError(err),
          });
      } else {
        this.commonService
          .post('/jobpost/post-exam-statuses/', payload)

          .subscribe({
            next: (res: any) => {
              this.currentExamId = res.id;

              // The record exists now — mark the row so closing the dialog
              // here shows "Manage Onboarding" and reopening loads this data.
              this.linkOnboardingRecord(this.selectedCandidate, res);

              this.currentOnboardingStep++;
            },
            error: (err) => this.handleError(err),
          });
      }
    }

    // STEP 2
    else {
      const payload = {
        offer_rolled_out_date: this.formatDate(form.offer_rolled_out_date),

        offer_amount: form.offer_amount,

        offer_details: form.offer_details,

        // Acceptance is owned by the Review step; send the current saved value.
        is_accepted: !!form.is_accepted,

        attached_cv: this.selectedCandidate.id,
      };

      this.commonService
        .patch(`/jobpost/post-exam-statuses/${this.currentExamId}/`, payload)

        .subscribe({
          next: () => {
          this.onboardingChanged = true;
          this.currentOnboardingStep++;

          // The preview is built server-side from the record that was
          // just saved, so it is requested after the PATCH lands.
          this.loadOfferPreview();
          },
          error: (err) => this.handleError(err),
        });
    }
  }

  /** Set once anything is saved from the onboarding dialog, so closing it
   *  refreshes the candidate list (status / onboarding columns). */
  private onboardingChanged = false;

  /**
   * Points the candidate row at its post-exam record straight away
   * (examStatusId drives the "Manage Onboarding" button and the GET that
   * pre-fills the dialog), without waiting for a page reload.
   */
  private linkOnboardingRecord(candidate: any, record: any): void {
    if (!candidate || !record?.id) return;
    this.onboardingChanged = true;
    const apply = (row: any) => {
      row.examStatusId = record.id;
      row.examStatus = { ...(row.examStatus || {}), ...record };
    };
    apply(candidate);
    const row = this.candidateMap.get(candidate.id);
    if (row && row !== candidate) apply(row);
  }

  /** Onboarding dialog closed (X, Cancel, Esc or after submit). */
  onOnboardingDialogHide(): void {
    if (this.onboardingChanged) {
      this.onboardingChanged = false;
      this.getCandidates();
    }
  }

  prevStep() {
    if (this.currentOnboardingStep > 0) {
      this.currentOnboardingStep--;

      if (this.currentOnboardingStep === this.STEP_REVIEW) {
        this.loadOfferPreview();
      }
    }
  }
  submitOnboarding() {
    if (this.onboardingForm.invalid) {
      this.onboardingForm.markAllAsTouched();
      return;
    }

    this.isSubmitLoading = true;

    const form = this.onboardingForm.value;

    // UPDATE — the record already exists (created on Step 1's Next click),
    // so only send the id (via URL) + the fields owned by this final
    // Onboarding step, not the entire form again.
    if (this.currentExamId) {
      const payload = {
        onboarding_date: form.onboarding_date
          ? this.formatDate(form.onboarding_date)
          : null,

        onboarding_status: form.onboarding_status,

        additional_info: form.additional_info,

        is_accepted: !!form.is_accepted,

        attached_cv: this.selectedCandidate.id,
      };

      this.commonService
        .patch(
          `/jobpost/post-exam-statuses/${this.currentExamId}/`,

          payload,
        )
        .subscribe({
          next: () => {
            this.handleSuccess('Onboarding updated successfully');
          },

          error: (err) => {
            this.handleError(err);
          },
        });

      return;
    }

    // CREATE — fallback for the (normally unreachable) case where the
    // dialogue reaches the final step without a record already having been
    // created on Step 1; nothing to update yet, so the full form is sent.
    const payload = {
      interview_date: form.interview_date
        ? this.formatDate(form.interview_date)
        : null,

      interviewer_name: form.interviewer_name,

      interview_feedback: form.interview_feedback,

      interview_result: form.interview_result,

      offer_rolled_out_date: form.offer_rolled_out_date
        ? this.formatDate(form.offer_rolled_out_date)
        : null,

      offer_amount: form.offer_amount,

      offer_details: form.offer_details,

      is_accepted: form.is_accepted,

      onboarding_date: form.onboarding_date
        ? this.formatDate(form.onboarding_date)
        : null,

      onboarding_status: form.onboarding_status,

      additional_info: form.additional_info,

      attached_cv: this.selectedCandidate.id,
    };

    this.commonService
      .post(
        '/jobpost/post-exam-statuses/',

        payload,
      )
      .subscribe({
        next: () => {
          this.handleSuccess('Onboarding submitted successfully');
        },

        error: (err) => {
          this.handleError(err);
        },
      });
  }

  handleSuccess(message: string) {
    this.isSubmitLoading = false;

    this.toaster.showSuccess(message);

    this.examDialogVisible = false;

    this.currentOnboardingStep = 0;

    this.currentExamId = null;

    this.onboardingForm.reset();

    this.onboardingForm.patchValue({
      is_accepted: false,

      onboarding_status: 'Pending',
    });

    this.onboardingChanged = false; // refreshing here, so the dialog's onHide needn't
    this.getCandidates();
  }

  handleError(err: any) {
    this.isSubmitLoading = false;

    const body = err?.error;
    let msg = 'Operation Failed';
    if (typeof body === 'string' && body) msg = body;
    else if (body?.message || body?.error || body?.detail) msg = String(body.message || body.error || body.detail);
    else if (body && typeof body === 'object') {
      const key = Object.keys(body)[0];
      const v = key ? (Array.isArray(body[key]) ? body[key][0] : body[key]) : null;
      if (typeof v === 'string' && v) msg = `${key.replace(/_/g, ' ')}: ${v}`;
    }
    this.toaster.showError(msg);
  }

  getJobDetails() {
    this.commonService.get(`/jobpost/post-jobs/${this.jobId}/`).subscribe({
      next: (res) => {
        this.jobDetails = res;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching job details', err);
        this.loading = false;
      },
    });
  }
  goBack() {
    this.location.back();
  }
  filterCandidates() {
    const query = (this.searchText || '').trim().toLowerCase();

    this.filteredCandidates = this.candidates.filter(
      (c) =>
        (!query ||
          String(c.name || '').toLowerCase().includes(query) ||
          String(c.email || '').toLowerCase().includes(query)) &&
        // Both default to 'all', so with the dropdowns untouched this
        // matches the previous search-only behaviour exactly.
        this.matchesApprovalFilter(c) &&
        this.matchesStageFilter(c) &&
        (!this.showFailedOnly || this.isFailedCv(c)),
    );

    this.first = 0;

    this.updatePaginatedCandidates();
  }

  /* ================= TOOLBAR FILTERS (client-side only) =================
     These narrow the already-fetched list in the same way the search box
     always has — no extra requests and no change to any API.
     ===================================================================== */

  approvalFilter: string = 'all';
  stageFilter: string = 'all';

  approvalFilterOptions = [
    { label: 'All approvals', value: 'all' },
    { label: 'Approved', value: 'approved' },
    { label: 'Pending', value: 'pending' },
    { label: 'Rejected', value: 'rejected' },
  ];

  stageFilterOptions = [
    { label: 'All stages', value: 'all' },
    { label: 'Invite sent', value: 'invited' },
    { label: 'Invite pending', value: 'not_invited' },
    { label: 'Selected', value: 'selected' },
    { label: 'Rejected', value: 'rejected' },
    { label: 'In progress', value: 'inprogress' },
    { label: 'On hold', value: 'hold' },
  ];

  private matchesApprovalFilter(candidate: any): boolean {
    switch (this.approvalFilter) {
      case 'approved':
        return candidate.approved === true;
      case 'rejected':
        return candidate.approved === false;
      case 'pending':
        return candidate.approved === null || candidate.approved === undefined;
      default:
        return true;
    }
  }

  /* ================= FAILED CV UPLOADS =================
     /jobpost/attached-cvs/ returns processing_status "failed" with a raw
     failure_reason (often a database error). Show it in plain words. */

  /** "Show failed only" toggle on the failed-CVs banner. */
  showFailedOnly = false;

  isFailedCv(candidate: any): boolean {
    return String(candidate?.processingStatus || '').toLowerCase() === 'failed';
  }

  get failedCvCount(): number {
    return this.candidates.filter((c) => this.isFailedCv(c)).length;
  }

  toggleFailedOnly(): void {
    this.showFailedOnly = !this.showFailedOnly;
    this.filterCandidates();
  }

  /** "AI_ML_Resume_4_Neha_gMPkug6.pdf" from the cv_file URL. */
  cvFileName(url: string | null | undefined): string {
    if (!url) return '';
    try {
      const last = decodeURIComponent(String(url).split('?')[0].split('/').pop() || '');
      return last;
    } catch {
      return String(url).split('/').pop() || '';
    }
  }

  /**
   * Plain-language explanation of a failed CV for recruiters — no
   * technical words. The backend's failure_reason is only used to pick
   * which explanation to show.
   */
  failureInfo(raw: string | null | undefined): { title: string; message: string; fix: string } {
    const text = String(raw || '');
    const dup = text.match(/Key \(([^)]+)\)=\(([^)]*)\) already exists/i);
    const field = dup ? dup[1] : '';

    if (/phone/i.test(field) || (/already exists|duplicate/i.test(text) && /phone/i.test(text))) {
      return {
        title: 'Phone number already in use',
        message: 'The phone number in this CV is already used by another candidate.',
        fix: 'Update the phone number in the CV and upload it again.',
      };
    }
    if (/email/i.test(field) || (/already exists|duplicate/i.test(text) && /email/i.test(text))) {
      return {
        title: 'Email already in use',
        message: 'The email address in this CV is already used by another candidate.',
        fix: 'Update the email address in the CV and upload it again.',
      };
    }
    if (/already exists|duplicate|unique/i.test(text)) {
      return {
        title: 'Candidate already exists',
        message: 'A candidate with the same details is already in the system.',
        fix: 'Check the existing candidate, or update the details in the CV and upload it again.',
      };
    }
    if (/password|encrypt/i.test(text)) {
      return {
        title: 'CV is password-protected',
        message: 'The CV file is locked with a password, so it could not be opened.',
        fix: 'Upload a copy of the CV without a password.',
      };
    }
    if (/no text|empty|could not extract|unable to extract|unreadable|scanned|no content/i.test(text)) {
      return {
        title: 'CV could not be read',
        message: 'The file looks empty or like a scanned image, so no text could be read.',
        fix: 'Upload a text-based PDF or Word file.',
      };
    }
    if (/no email|email not found|missing email|email.*required/i.test(text)) {
      return {
        title: 'Email missing',
        message: 'No email address was found in this CV.',
        fix: 'Add an email address to the CV and upload it again.',
      };
    }
    if (/unsupported|invalid file|not a pdf|file type|format/i.test(text)) {
      return {
        title: 'File type not supported',
        message: 'This type of file can’t be used as a CV.',
        fix: 'Upload the CV as a PDF or Word file.',
      };
    }
    if (/time ?out|timed out/i.test(text)) {
      return {
        title: 'Took too long',
        message: 'Reading this CV took too long and was stopped.',
        fix: 'Please upload the CV again.',
      };
    }
    if (/quota|limit|429|too many/i.test(text)) {
      return {
        title: 'Upload limit reached',
        message: 'The CV upload limit has been reached for now.',
        fix: 'Please try again later.',
      };
    }
    return {
      title: 'Upload failed',
      message: 'Something went wrong while reading this CV.',
      fix: 'Please check the file and upload it again. If it keeps failing, contact support.',
    };
  }

  /* ---- "Why this CV failed" dialog ---- */
  failureDialogVisible = false;
  failureDialogCandidate: any = null;

  openFailureDetails(candidate: any): void {
    if (!this.isFailedCv(candidate)) return;
    this.failureDialogCandidate = candidate;
    this.failureDialogVisible = true;
  }

  private matchesStageFilter(candidate: any): boolean {
    switch (this.stageFilter) {
      case 'invited':
        return !!candidate.examInviteSent;
      case 'not_invited':
        return !candidate.examInviteSent;
      case 'selected':
      case 'rejected':
      case 'inprogress':
      case 'hold':
        return candidate.recruiterAction === this.stageFilter;
      default:
        return true;
    }
  }

  /* ===================== PRESENTATION HELPERS =====================
     Labels, tones and the onboarding button's state. All derived from
     values the candidate list already carries — nothing is fetched or
     stored here.
     =============================================================== */

  /** Row whose recruitment-decision dropdown is currently open, if any. */
  editingDecisionFor: any = null;

  /** Collapses the job description until the reader expands it. */
  descriptionExpanded = false;

  /**
   * Which of the three presentations the Recruitment Decision cell uses:
   *   'locked' — candidate not approved yet, so no decision can be made
   *   'set'    — a decision exists: show it as a pill with an edit button
   *   'choose' — approved with no decision, or the row is being edited
   *
   * Approval is the gate, exactly as it is for the onboarding column: a
   * decision cannot be recorded for someone who has not been cleared.
   */
  decisionState(candidate: any): 'locked' | 'choose' | 'set' {
    if (candidate?.approved !== true) return 'locked';
    if (this.editingDecisionFor === candidate) return 'choose';
    return candidate?.recruiterAction ? 'set' : 'choose';
  }

  decisionLabel(action: string | null | undefined): string {
    const match = this.recruiterStatusOptions.find((o) => o.value === action);
    return match ? match.label : 'Select Status';
  }

  decisionTone(action: string | null | undefined): string {
    switch (action) {
      case 'selected':
        return 'tone-success';
      case 'rejected':
        return 'tone-danger';
      case 'hold':
        return 'tone-warning';
      case 'inprogress':
        return 'tone-info';
      default:
        return 'tone-muted';
    }
  }

  /**
   * Which of the three onboarding states a row is in:
   *   'manage'  — a post-exam record already exists for this candidate
   *   'start'   — approved and cleared to proceed, nothing recorded yet
   *   'blocked' — still awaiting approval, or rejected outright
   *
   * Gated on approval rather than the recruitment decision: a candidate
   * can be approved and part-way through rounds long before a final
   * decision exists, and that is exactly when the interview outcome
   * needs recording.
   */
  onboardingState(candidate: any): 'manage' | 'start' | 'blocked' {
    if (candidate?.examStatusId) return 'manage';
    if (candidate?.approved !== true) return 'blocked';
    if (candidate?.recruiterAction === 'rejected') return 'blocked';
    return 'start';
  }

  onboardingLabel(candidate: any): string {
    switch (this.onboardingState(candidate)) {
      case 'manage':
        return 'Manage Onboarding';
      case 'start':
        return 'Start Onboarding';
      default:
        return 'Manage Onboarding';
    }
  }

  onboardingHint(candidate: any): string {
    switch (this.onboardingState(candidate)) {
      case 'manage':
        return 'Review or update interview, offer and onboarding details';
      case 'start':
        return 'Record interview outcome, offer and onboarding details';
      default:
        return candidate?.approved === false
          ? 'Not available — this candidate was rejected'
          : 'Available once this candidate has been approved';
    }
  }

  /** Last row number on the current page, for the "Showing x to y" line. */
  get pageEnd(): number {
    return Math.min(this.first + this.rows, this.filteredCandidates.length);
  }

  /** Reference code shown in the breadcrumb and beside the title. */
  get jobReference(): string {
    const ref =
      this.jobDetails?.job_code ||
      this.jobDetails?.reference_id ||
      this.jobDetails?.req_id ||
      (this.jobDetails?.id ? `REQ-${this.jobDetails.id}` : '');
    return ref ? `${ref}` : '';
  }

  get jobPostedOn(): string | null {
    return (
      this.jobDetails?.created_at ||
      this.jobDetails?.posted_on ||
      this.jobDetails?.created_on ||
      null
    );
  }

  get jobDepartment(): string {
    return (
      this.jobDetails?.department_name ||
      this.jobDetails?.job_category ||
      this.jobDetails?.department ||
      ''
    );
  }
  getCandidates() {
    this.commonService
      .get(`/jobpost/attached-cvs/?job_post=${this.jobId}`)
      .subscribe({
        next: (res: any[]) => {
          this.candidates = res.map((cv) => {
            const mcqRound = cv.round_progress?.find(
              (r: any) => r.round_type === 'EXAM',
            );

            const codingRound = cv.round_progress?.find(
              (r: any) => r.round_type === 'PRACTICE',
            );

            return {
              id: cv.id,

              // The manual-interview endpoints are keyed off the candidate id,
              // not the attached-CV id.
              candidateId: cv.candidate ?? cv.candidate_details?.id ?? null,

              name: cv.name,
              email: cv.emails,
              mobile: cv.candidate_details?.phone,
              keywords: cv.matching_words,

              approved: cv.approved,
              status: cv.approved ? 'Approved' : 'Pending',

              examInviteSent: cv.exam_invite_sent,

              resumeUrl: cv.cv_file,

              examStatus: cv.status?.[0] || null,
              examStatusId: cv.status?.[0]?.id || null,

              processingStatus: cv.processing_status,
              failureReason: cv.failure_reason || null,
              failure:
                String(cv.processing_status || '').toLowerCase() === 'failed'
                  ? this.failureInfo(cv.failure_reason)
                  : null,
              fileName: this.cvFileName(cv.cv_file),

              mcqScore: mcqRound?.score ?? '-',
              mcqStatus: mcqRound?.status ?? '-',

              codingScore: codingRound?.score ?? '-',
              codingStatus: codingRound?.status ?? '-',

              // Full per-round history (EXAM/PRACTICE/INTERVIEW_MANUAL/
              // INTERVIEW_BOT), used by the "Exam Status" column + dialog.
              roundProgress: cv.round_progress || [],
              schedule_id: cv.schedule_id,
            };
          });

          // Build lookup map
          this.candidateMap.clear();

          this.candidates.forEach((c) => {
            this.candidateMap.set(c.id, c);
          });

          // This is the normal (un-ranked) list, so leave ranking mode —
          // otherwise the Rank / Score columns stay on screen with no values.
          this.isRanked = false;
          this.isRankingDone = false;

          // Drop selections for candidates that are no longer in the list.
          const ids = new Set(this.candidates.map((c) => c.id));
          Array.from(this.selectedCandidateIds).forEach((id: any) => {
            if (!ids.has(id)) this.selectedCandidateIds.delete(id);
          });

          // Keep the user's search / filters and page instead of resetting them.
          this.refreshCandidateView();

          this.getCandidateRoundProgress();

          const hasPending = this.candidates.some((c) =>
            ['pending', 'processing', 'in_progress'].includes(
              c.processingStatus?.toLowerCase(),
            ),
          );

          if (hasPending) {
            this.startPolling();
          } else {
            this.stopPolling();
          }
        },
        error: (err) => {
          console.log(err);
        },
      });
  }

  /** Re-applies search + filters to `candidates` without jumping back to page 1
   *  (unless the current page no longer exists). Use after any data refresh. */
  refreshCandidateView(): void {
    const keepFirst = this.first;
    this.filterCandidates();
    this.first = keepFirst < this.filteredCandidates.length ? keepFirst : 0;
    this.updatePaginatedCandidates();
  }

  updatePaginatedCandidates() {
    this.paginatedCandidates = this.filteredCandidates.slice(
      this.first,
      this.first + this.rows,
    );
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;

    this.updatePaginatedCandidates();
  }

  rankCVs() {
    if (!this.jobId) return;

    this.rankingLoading = true;

    this.commonService
      .get(`/jobpost/post-jobs/${this.jobId}/rank-cvs/`, {})
      .subscribe({
        next: (res: any) => {
          this.isRanked = true;

          // Ranking returns only ranking data. Merge it onto the row we already
          // have so actions (resume, exam invite, interview, approve…) keep working.
          this.candidates = (res?.ranked_candidates || []).map((candidate: any) => ({
            ...(this.candidateMap.get(candidate.attached_cv_id) || {}),
            id: candidate.attached_cv_id,
            rank: candidate.rank,
            totalScore: candidate.total_score,
            name: candidate.candidate_name,
            email: candidate.email,
            mobile: candidate.phone,
            approved: candidate.approved,
            status: candidate.approved ? 'Approved' : 'Pending',
            scoreBreakdown: candidate.score_breakdown,
            candidateType: candidate.candidate_type,
            experience: candidate.years_of_experience,
            location: candidate.location,
            strengths: candidate.strengths || [],
            weaknesses: candidate.weaknesses || [],
            skills: candidate.skills || {},
            jdMatch: candidate.jd_match || {
              matching_words: [],
              matching_word_count: 0,
            },
            education: candidate.education || [],
            certifications: candidate.certifications || [],
            employment: candidate.employment || [],
          }));

          this.candidateMap.clear();
          this.candidates.forEach((c) => this.candidateMap.set(c.id, c));

          this.filteredCandidates = [...this.candidates];
          this.first = 0; // ← reset to page 1
          this.updatePaginatedCandidates(); // ← rebuild the slice the table actually reads
          this.selectedCandidateIds.clear(); // ← optional but recommended, see note below

          this.rankingLoading = false;
          this.isRankingDone = true;
        },

        error: (err) => {
          console.error('Ranking Error:', err);
          this.rankingLoading = false;
          this.toaster.showError('Failed to rank CVs');
        },
      });
  }

  get scorePercent() {
    return this.selectedCandidate?.totalScore || 0;
  }

  get scoreDashoffset(): number {
    const score = this.selectedCandidate?.totalScore || 0;

    return this.scoreCircumference - (score / 100) * this.scoreCircumference;
  }

  openUploadDialog() {
    this.uploadDialogVisible = true;
  }

  closeUploadDialog() {
    this.uploadDialogVisible = false;
    this.selectedFiles = [];
    this.fileError = '';

    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }

  removeFile(index: number) {
    this.selectedFiles.splice(index, 1);
    this.fileError = '';

    if (this.fileInput && this.selectedFiles.length === 0) {
      this.fileInput.nativeElement.value = '';
    }
  }

  onFileSelect(event: any) {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;

    const allowedTypes = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ];

    const validFiles: File[] = [];
    this.fileError = '';

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (!allowedTypes.includes(file.type)) {
        this.fileError = 'Only PDF or DOC/DOCX files allowed';
        return;
      }

      if (file.size > 2 * 1024 * 1024) {
        this.fileError = 'Each file must be less than 2MB';
        return;
      }

      validFiles.push(file);
    }

    this.selectedFiles = [...this.selectedFiles, ...validFiles];
  }

  uploadResume() {
    if (!this.selectedFiles.length) return;

    this.uploading = true;
    const formData = new FormData();

    // Append each file to 'cv_files' key
    this.selectedFiles.forEach((file) => {
      formData.append('cv_files', file);
    });

    formData.append('post_job', this.jobId);

    this.commonService
      .postFormData('/jobpost/attached-cvs/', formData)
      .subscribe({
        next: (response: any) => {
          this.uploading = false;
          this.closeUploadDialog();
          // Always re-fetch: the upload response isn't in the table's row shape.
          this.getCandidates();
          this.toaster.showSuccess('CV(s) uploaded successfully');
        },
        error: (err: any) => {
          this.uploading = false;
          this.toaster.showError(err?.error?.message || 'Failed to upload CVs');
        },
      });
  }
  viewResume(candidate: any) {
    if (!candidate.resumeUrl) {
      this.toaster.showError('No resume available');
      return;
    }

    window.open(candidate.resumeUrl, '_blank');
  }

  // ===================== ROW ACTIONS MENU =====================
  // Single popup p-menu shared across all rows — items are rebuilt for
  // whichever candidate's kebab button was just clicked, right before the
  // menu opens. Consolidates what used to be several separate icon buttons
  // (plus a standalone "Post Exam Status" column) into one menu per row.
  // "View Ranking Details" stays outside the menu as its own button.
  // Every item calls the exact same existing method the old inline
  // buttons called — no behavior has changed, only where it's triggered
  // from.
  activeRowMenuItems: MenuItem[] = [];

  openRowActionsMenu(event: Event, candidate: any, menu: any) {
    const items: MenuItem[] = [];

    items.push(
      {
        label: 'View Resume',
        icon: 'pi pi-eye',
        command: () => this.viewResume(candidate),
      },
      {
        // No handler was wired to the old "Download" button either — kept
        // as-is so behavior doesn't change.
        label: 'Download',
        icon: 'pi pi-download',
      },
      {
        label: 'View Email Logs & Timeline',
        icon: 'pi pi-history',
        command: () => this.viewTimeline(candidate),
      },
      {
        label: 'View Hiring Report',
        icon: 'pi pi-chart-bar',
        command: () => this.viewHiringReport(candidate),
      },
      {
        label: 'Schedule Manual Interview',
        icon: 'pi pi-calendar-plus',
        command: () => this.openManualScheduleDialog(candidate),
      },
    );

    // "Post Exam Status" used to live here. It is now a visible
    // "Manage Onboarding" button in its own column (see the template), so
    // it is deliberately not duplicated in this menu — openExamStatusDialog
    // is unchanged and is called straight from that button.

    this.activeRowMenuItems = items;
    menu.toggle(event);
  }

  formatDate(date: any) {
    if (!date) return null;

    // Built from local parts: toISOString() shifts to UTC and would send the
    // previous day for anyone east of Greenwich (IST included).
    const d = new Date(date);

    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  }

  // ===================== SCHEDULE MANUAL INTERVIEW =====================

  /** Interviews scheduled/loaded in this visit, keyed by attached-CV id, so
   *  reopening the dialog shows the booking without waiting for a reload. */
  private manualScheduleCache = new Map<number, any>();

  openManualScheduleDialog(candidate: any) {
    this.selectedCandidate = candidate;
    this.manualScheduleResult = this.manualScheduleCache.get(candidate?.id) || null;
    this.manualScheduleLoadError = '';
    this.isEditingSchedule = false;
    this.meetingIdCopied = false;
    this.manualScheduleForm.reset();
    this.manualScheduleDialogVisible = true;

    this.loadManualSchedule();
  }

  closeManualScheduleDialog() {
    this.manualScheduleDialogVisible = false;
    this.isEditingSchedule = false;
  }

  /**
   * GET /interview/manual-schedule/{candidate_id}/
   * Shows the existing booking when there is one; a 404 just means the
   * candidate has not been scheduled yet, so the create form is shown.
   */
  loadManualSchedule(): void {
    const candidateId = this.manualScheduleCandidateId;

    if (!candidateId) {
      this.manualScheduleLoading = false;
      return;
    }

    this.manualScheduleLoading = true;
    this.manualScheduleLoadError = '';

    this.commonService
      .get(`/interview/manual-schedule/${candidateId}/`)
      .subscribe({
        next: (res: any) => {
          this.manualScheduleLoading = false;
          const record = this.normalizeSchedule(res);
          // Keep what we already know if the server answers with nothing.
          this.manualScheduleResult = record || this.manualScheduleCache.get(this.selectedCandidate?.id) || null;
          if (record) this.rememberSchedule(this.selectedCandidate, record);
        },

        error: (err: any) => {
          this.manualScheduleLoading = false;
          this.manualScheduleResult = this.manualScheduleCache.get(this.selectedCandidate?.id) || null;

          if (err?.status && err.status !== 404) {
            this.manualScheduleLoadError =
              'Could not check for an existing interview.';
          }
        },
      });
  }

  /** Candidate id carried through from /jobpost/attached-cvs/. */
  private get manualScheduleCandidateId(): number | null {
    return (
      this.selectedCandidate?.schedule_id ??
      this.selectedCandidate?.schedule_id ??
      null
    );
  }

  /**
   * Stores a booking against the candidate row (and the cache) so the next
   * open of the dialog — and the row's own schedule_id — are up to date
   * without reloading the page.
   */
  private rememberSchedule(candidate: any, schedule: any): void {
    if (!candidate || !schedule) return;
    this.manualScheduleCache.set(candidate.id, schedule);
    if (schedule.id) {
      candidate.schedule_id = schedule.id;
      const row = this.candidateMap.get(candidate.id);
      if (row && row !== candidate) row.schedule_id = schedule.id;
    }
  }

  /** The endpoint may answer with an object, a list, or nothing at all. */
  private normalizeSchedule(res: any): any {
    const record = Array.isArray(res) ? res[0] : res;

    return record && record.id ? record : null;
  }

  /* ------------------------------ Editing ------------------------------ */

  startEditSchedule(): void {
    if (!this.manualScheduleResult) {
      return;
    }

    this.manualScheduleForm.patchValue({
      scheduled_date: this.parseApiDate(
        this.manualScheduleResult.scheduled_date,
      ),
      start_time: this.parseApiTime(this.manualScheduleResult.start_time),
    });

    this.isEditingSchedule = true;
  }

  cancelEditSchedule(): void {
    this.isEditingSchedule = false;
    this.manualScheduleForm.reset();
  }

  /* ---------------------------- Presentation ---------------------------- */

  get scheduledDateLabel(): string {
    const parsed = this.parseApiDate(this.manualScheduleResult?.scheduled_date);

    if (!parsed) {
      return this.manualScheduleResult?.scheduled_date || '-';
    }

    return parsed.toLocaleDateString([], {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  }

  get scheduledTimeLabel(): string {
    const parsed = this.parseApiTime(this.manualScheduleResult?.start_time);

    if (!parsed) {
      return this.manualScheduleResult?.start_time || '-';
    }

    return parsed.toLocaleTimeString([], {
      hour: 'numeric',
      minute: '2-digit',
    });
  }

  copyMeetingId(): void {
    const meetingId = this.manualScheduleResult?.teams_meeting_id;

    if (!meetingId) {
      return;
    }

    const copied = navigator.clipboard?.writeText(meetingId);

    if (!copied) {
      this.toaster.showError('Could not copy the meeting ID');
      return;
    }

    copied.then(
      () => {
        this.meetingIdCopied = true;

        setTimeout(() => (this.meetingIdCopied = false), 1800);
      },

      () => this.toaster.showError('Could not copy the meeting ID'),
    );
  }

  /** "2026-09-01" -> local Date, so p-calendar shows the same day. */
  private parseApiDate(value: string): Date | null {
    if (!value) return null;

    const [year, month, day] = String(value).split('-').map(Number);

    if (!year || !month || !day) return null;

    return new Date(year, month - 1, day);
  }

  /** "17:55:23" -> a Date carrying that wall-clock time. */
  private parseApiTime(value: string): Date | null {
    if (!value) return null;

    const [hh, mm, ss] = String(value).split(':').map(Number);

    if (Number.isNaN(hh)) return null;

    const d = new Date();
    d.setHours(hh || 0, mm || 0, ss || 0, 0);

    return d;
  }

  isManualScheduleInvalid(field: string): boolean {
    const control = this.manualScheduleForm.get(field);
    return !!control && control.invalid && (control.dirty || control.touched);
  }

  private formatTimeForApi(date: any): string | null {
    if (!date) return null;

    const d = new Date(date);
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    const ss = String(d.getSeconds()).padStart(2, '0');

    return `${hh}:${mm}:${ss}`;
  }

  submitManualSchedule(): void {
    if (this.manualScheduleForm.invalid) {
      this.manualScheduleForm.markAllAsTouched();
      return;
    }

    const { scheduled_date, start_time } = this.manualScheduleForm.value;

    const scheduleId = this.manualScheduleResult?.id;
    const isEdit = this.isEditingSchedule && !!scheduleId;

    const payload: any = {
      scheduled_date: this.formatDate(scheduled_date),
      start_time: this.formatTimeForApi(start_time),
    };

    if (!isEdit) {
      payload.attached_cv = this.selectedCandidate?.id;
    }

    this.isManualScheduling = true;

    // Create -> POST /interview/manual-schedule/
    // Edit   -> PATCH /interview/manual-schedule/{schedule_id}/
    const request$ = isEdit
      ? this.commonService.patch(
          `/interview/manual-schedule/${scheduleId}/`,
          payload,
        )
      : this.commonService.post('/interview/manual-schedule/', payload);

    request$.subscribe({
      next: (res: any) => {
        this.isManualScheduling = false;

        this.manualScheduleResult = this.normalizeSchedule(res) || {
          ...this.manualScheduleResult,
          ...payload,
        };
        this.rememberSchedule(this.selectedCandidate, this.manualScheduleResult);

        this.isEditingSchedule = false;
        this.manualScheduleForm.reset();

        this.toaster.showSuccess(
          isEdit
            ? 'Interview rescheduled successfully!'
            : 'Interview scheduled successfully!',
        );
      },

      error: (err: any) => {
        this.isManualScheduling = false;

        this.toaster.showError(
          err?.error?.message ||
            (isEdit
              ? 'Failed to update the interview. Please try again.'
              : 'Failed to schedule interview. Please try again.'),
        );
      },
    });
  }

  openExamStatusDialog(candidate: any) {
    this.selectedCandidate = candidate;

    this.currentOnboardingStep = 0;

    // Per-candidate review state starts clean; the offer template is an
    // org setting, so it is restored rather than reset.
    this.offerSent = false;
    this.isSendingOffer = false;
    this.templatePickerOpen = false;
    this.candidateLetterFile = null;
    this.templateChoice = 'standard';
    this.sentLetterUrl = '';
    this.offerPreviewTo = '';
    this.offerPreviewSubject = '';
    this.offerPreviewHtml = null;
    this.previewError = '';
    this.loadingPreview = false;

    // Org-level, so it is fetched rather than reset per candidate.
    this.loadOrgTemplate();

    this.onboardingChanged = false;
    this.examDialogVisible = true;

    if (candidate.examStatusId) {
      this.commonService
        .get(`/jobpost/post-exam-statuses/${candidate.examStatusId}/`)
        .subscribe({
          next: (data: any) => {
            this.currentExamId = data.id;

            this.onboardingForm.patchValue({
              interviewer_name: data.interviewer_name,

              interview_date: data.interview_date
                ? new Date(data.interview_date)
                : null,

              interview_result: data.interview_result,

              interview_feedback: data.interview_feedback,

              offer_rolled_out_date: data.offer_rolled_out_date
                ? new Date(data.offer_rolled_out_date)
                : null,

              offer_amount: data.offer_amount,

              offer_details: data.offer_details,

              is_accepted: data.is_accepted,

              onboarding_date: data.onboarding_date
                ? new Date(data.onboarding_date)
                : null,

              onboarding_status: data.onboarding_status,

              additional_info: data.additional_info,
            });

            // A record that already carries a letter has been sent once,
            // so the Review step opens in its sent state rather than
            // offering to send again from scratch.
            if (data.offer_letter_file) {
              this.sentLetterUrl = this.mediaUrl(data.offer_letter_file);
              this.offerSent = true;
            }
          },

          error: () => {
            this.toaster.showError('Unable to load data');
          },
        });
    } else {
      this.currentExamId = null;

      this.onboardingForm.reset();

      this.onboardingForm.patchValue({
        is_accepted: false,

        onboarding_status: 'Pending',
      });
    }
  }

  validateCurrentStep(): boolean {
    let controls: string[] = [];

    switch (this.currentOnboardingStep) {
      case this.STEP_INTERVIEW:
        controls = [
          'interview_mode',
          'interviewer_name',
          'interview_date',
          'interview_result',
        ];
        break;

      case this.STEP_OFFER:
        controls = ['offer_rolled_out_date', 'offer_amount', 'offer_details'];
        break;

      // Review owns no inputs — everything on it is read-back of values
      // Step 2 already validated.
      case this.STEP_REVIEW:
        controls = [];
        break;

      case this.STEP_ONBOARDING:
        controls = ['onboarding_date', 'onboarding_status'];
        break;
    }

    controls.forEach((control) => {
      this.onboardingForm.get(control)?.markAsTouched();
    });

    return controls.every((control) => this.onboardingForm.get(control)?.valid);
  }

  isStep1Saved(): boolean {
    return !!this.originalExamData?.interview_date;
  }

  isStep2Saved(): boolean {
    return !!this.originalExamData?.offer_rolled_out_date;
  }

  isStep3Saved(): boolean {
    return !!this.originalExamData?.onboarding_date;
  }

  approveRejectCandidate(candidate: any, approved: boolean) {
    this.commonService
      .post(`/jobpost/attached-cv/${candidate.id}/approve/`, {
        approved: approved,
      })
      .subscribe({
        next: () => {
          candidate.approved = approved;

          this.toaster.showSuccess(
            approved
              ? 'Candidate Approved Successfully'
              : 'Candidate Rejected Successfully',
          );
        },
        error: (err) => {
          this.toaster.showError(err?.error?.message || 'Something went wrong');
        },
      });
  }

  getCandidateRoundProgress() {
    this.commonService.get('/jobpost/candidate-round-progress/').subscribe({
      next: (res: any[]) => {
        res.forEach((progress) => {
          const candidate = this.candidates.find(
            (c) => c.id === progress.attached_cv,
          );

          if (candidate) {
            candidate.roundProgressId = progress.id;
            candidate.examScore = progress.score;
            candidate.recruiterAction = progress.recruiter_action;
          }
        });
        // Rows are updated in place — keep the current filters / page.
        this.refreshCandidateView();
      },
    });
  }

  updateRecruiterAction(candidate: any, action: string) {
    const roundProgressId = candidate.roundProgressId;

    if (!roundProgressId) {
      this.toaster.showError(
        'Status cannot be changed until the candidate attempts at least one exam round.',
      );
      return;
    }
    const payload = {
      recruiter_action: action,
    };

    this.commonService
      .patch(
        `/jobpost/candidate-round-progress/${candidate.roundProgressId}/update-round-action/`,

        payload,
      )
      .subscribe({
        next: () => {
          candidate.recruiterAction = action;

          this.toaster.showSuccess('Status updated successfully');
        },

        error: () => {
          this.toaster.showError('Unable to update status');
        },
      });
  }

  isCandidateSelected(candidate: any): boolean {
    return this.selectedCandidateIds.has(candidate.id);
  }

  toggleCandidateSelection(candidate: any) {
    if (candidate.approved !== true) return;

    if (this.selectedCandidateIds.has(candidate.id)) {
      this.selectedCandidateIds.delete(candidate.id);
    } else {
      this.selectedCandidateIds.add(candidate.id);
    }
  }

  toggleSelectAllApproved() {
    const approved = this.approvedCandidates;

    if (this.isAllApprovedSelected) {
      approved.forEach((c) => this.selectedCandidateIds.delete(c.id));
    } else {
      approved.forEach((c) => this.selectedCandidateIds.add(c.id));
    }
  }

  clearSelection() {
    this.selectedCandidateIds.clear();
  }

  notifyRecruiter() {
    if (!this.selectedCandidateIds.size || this.notifyingRecruiter) return;

    this.notifyingRecruiter = true;
    const payload = { cv_ids: Array.from(this.selectedCandidateIds) };

    this.commonService
      .post('/jobpost/attached-cv/notify-recruiter/', payload)
      .subscribe({
        next: () => {
          this.notifyingRecruiter = false;
          this.toaster.showSuccess(
            `Recruiter notified for ${payload.cv_ids.length} candidate(s).`,
          );
          this.clearSelection();
          this.getCandidates();
        },
        error: (err) => {
          this.notifyingRecruiter = false;
          this.toaster.showError(
            err?.error?.message || 'Failed to notify recruiter',
          );
        },
      });
  }

  sendingExamInvite = false;

  sendExamInvite() {
    if (!this.selectedCandidateIds.size || this.sendingExamInvite) return;

    this.sendingExamInvite = true;

    const payload = {
      cv_ids: Array.from(this.selectedCandidateIds),
    };

    this.commonService
      .post('/jobpost/attached-cv/send-exam-invite/', payload)
      .subscribe({
        next: (res: any) => {
          this.sendingExamInvite = false;

          if (res?.invites_sent_to_cv_ids?.length > 0) {
            // Success
            this.toaster.showSuccess(
              res?.message || 'Exam invite(s) sent successfully.',
            );
          }

          if (res?.invites_skipped?.length > 0) {
            // Warning
            const warningMessage = res.invites_skipped
              .map((item: any) => item.reason)
              .join('\n');

            this.toaster.showWarn(warningMessage);
          }

          this.clearSelection();
          this.getCandidates();
        },
        error: (err) => {
          this.sendingExamInvite = false;

          this.toaster.showError(
            err?.error?.message || 'Failed to send exam invite',
          );
        },
      });
  }

  timelineDialogVisible = false;
  timelineLoading = false;
  timelineData: any = null;

  viewTimeline(candidate: any) {
    this.timelineDialogVisible = true;
    this.timelineLoading = true;
    this.timelineData = null;

    this.commonService.get(`/jobpost/cv/${candidate.id}/timeline/`).subscribe({
      next: (res: any) => {
        this.timelineData = res;
        this.timelineLoading = false;
      },
      error: () => {
        this.timelineLoading = false;
        this.toaster.showError('Unable to load timeline');
      },
    });
  }

  closeTimelineDialog() {
    this.timelineDialogVisible = false;
    this.timelineData = null;
  }

  // Classifies each step's `value` so the template can pick an icon/color
  // without embedding logic in the markup.
  getStepStatus(step: any): 'done' | 'failed' | 'pending' | 'info' {
    if (step.value === true) return 'done';
    if (step.value === false) return 'pending';
    if (step.value === null) return 'info';
    // string values like "Pending" / "Completed" (e.g. onboarding_status)
    return step.value === 'Completed' ? 'done' : 'info';
  }

  get timelineCompletedCount(): number {
    if (!this.timelineData?.timeline) return 0;
    return this.timelineData.timeline.filter(
      (s: any) => this.getStepStatus(s) === 'done',
    ).length;
  }

  get timelineTotalCount(): number {
    return this.timelineData?.timeline?.length || 0;
  }

  get timelineProgressPercent(): number {
    if (!this.timelineTotalCount) return 0;
    return Math.round(
      (this.timelineCompletedCount / this.timelineTotalCount) * 100,
    );
  }

  // SVG ring circumference for stroke-dashoffset (r=26)
  readonly timelineRingCircumference = 2 * Math.PI * 26;

  get timelineRingOffset(): number {
    return (
      this.timelineRingCircumference -
      (this.timelineProgressPercent / 100) * this.timelineRingCircumference
    );
  }

  infoOverlayText = '';

  showInfo(event: Event, text: string, panel: any) {
    this.infoOverlayText = text;
    panel.toggle(event);
  }

  // ===================== HIRING REPORT =====================
  // Candidate's full exam + AI interview report now lives on its own page
  // (see modules/job-posting/hiring-report) so it can be linked to directly
  // and downloaded as a standalone PDF. This just navigates there with the
  // candidate's cv id.
  viewHiringReport(candidate: any) {
    this.router.navigate(['/job-posting/hiring-report', candidate.id]);
  }

  // getReportRoundBadgeClass / getReportStatusClass / getReportStatusLabel
  // below are still used by the "Exam & Round Status" dialog (table column)
  // further down this file, so they stay here even though the Hiring
  // Report dialog that used to share them has moved to its own page.

  // Badge color per round type — mirrors the palette already used for
  // EXAM / PRACTICE / INTERVIEW_MANUAL / INTERVIEW_BOT badges elsewhere.
  getReportRoundBadgeClass(roundType: string): string {
    switch (roundType) {
      case 'EXAM':
        return 'exam-badge';
      case 'PRACTICE':
        return 'practice-badge';
      case 'INTERVIEW_MANUAL':
        return 'interview-badge';
      case 'INTERVIEW_BOT':
        return 'bot-badge';
      default:
        return '';
    }
  }

  // Normalizes a round/round_progress status string into one of a small
  // set of visual states the template can style consistently.
  getReportStatusClass(status: string | null | undefined): string {
    const normalized = (status || '').toString().toLowerCase();

    if (['completed', 'passed', 'cleared', 'done'].includes(normalized)) {
      return 'done';
    }
    if (['failed', 'rejected'].includes(normalized)) {
      return 'failed';
    }
    if (['in_progress', 'pending', 'ongoing'].includes(normalized)) {
      return 'pending';
    }

    return 'muted'; // not_attempted / null / anything unrecognized
  }

  getReportStatusLabel(status: string | null | undefined): string {
    if (!status) return 'Not Attempted';

    return status
      .toString()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (c: string) => c.toUpperCase());
  }

  // ===================== EXAM & ROUND STATUS (table column) =====================
  // Uses the round_progress data already present in the attached-cvs
  // response (see getCandidates()) — no extra API call needed. Shows a
  // single compact "Exam Status" column that opens a details dialog for
  // that candidate's full round history on click.
  examRoundDialogVisible = false;
  examRoundCandidate: any = null;

  openExamRoundDetails(candidate: any) {
    this.examRoundCandidate = candidate;
    this.examRoundDialogVisible = true;
  }

  closeExamRoundDialog() {
    this.examRoundDialogVisible = false;
    this.examRoundCandidate = null;
  }

  // Readable label for a round_type when no *_display field is provided
  // by this endpoint (unlike the separate hiring-report API).
  formatRoundType(roundType: string | null | undefined): string {
    switch (roundType) {
      case 'EXAM':
        return 'Exam';
      case 'PRACTICE':
        return 'Coding Practice';
      case 'INTERVIEW_MANUAL':
        return 'Manual Interview';
      case 'INTERVIEW_BOT':
        return 'AI Interview';
      default:
        return this.getReportStatusLabel(roundType);
    }
  }

  // AI interview/exam feedback often comes back as raw markdown (###
  // headings, **bold**, etc. — see round_progress[].feedback). Strips the
  // markdown symbols so it reads as plain text instead of showing the
  // literal "#"/"*" characters, while keeping line breaks intact.
  formatFeedback(feedback: string | null | undefined): string {
    if (!feedback) return '';

    return feedback
      .replace(/^#{1,6}\s*/gm, '') // heading markers ("### Strengths:")
      .replace(/\*\*(.*?)\*\*/g, '$1') // **bold**
      .replace(/\*/g, '') // any remaining asterisks (italics/bullets)
      .replace(/`/g, '') // inline code backticks
      .trim();
  }

  // Aggregate summary shown in the table's compact "Exam Status" chip —
  // reuses getReportStatusClass() so the same status colors are used
  // consistently across this column and the Hiring Report dialog.
  getExamStatusMeta(candidate: any): {
    label: string;
    cls: string;
    icon: string;
  } {
    const rounds = candidate?.roundProgress || [];

    if (!rounds.length) {
      return { label: 'Not Attempted', cls: 'muted', icon: 'pi-minus-circle' };
    }

    const classes = rounds.map((r: any) => this.getReportStatusClass(r.status));
    const cls = classes.includes('failed')
      ? 'failed'
      : classes.includes('pending')
        ? 'pending'
        : classes.includes('done')
          ? 'done'
          : 'muted';

    const icon =
      cls === 'failed'
        ? 'pi-times-circle'
        : cls === 'pending'
          ? 'pi-clock'
          : cls === 'done'
            ? 'pi-check-circle'
            : 'pi-info-circle';

    const label = `${rounds.length} Round${rounds.length > 1 ? 's' : ''}`;

    return { label, cls, icon };
  }

  /**
   * Generates external link via API call and copies directly to clipboard
   */
  quickCopyExternalLink(job: any) {
    const jobId = job?.id || job?.job_post;
    if (!jobId || this.isGeneratingLink) return;

    this.isGeneratingLink = true;

    const payload = {
      job_post: jobId,
    };

    this.commonService.post('/jobpost/external-links/', payload).subscribe({
      next: (response: any) => {
        const link =
          response?.upload_url ||
          response?.link ||
          response?.url ||
          response?.external_link;

        if (link) {
          this.copyToClipboard(link);
        } else {
          this.toaster.showError(
            'Link generated, but standard URL was not found.',
          );
        }
      },
      error: (err) => {
        console.error('Error generating external link:', err);
        this.toaster.showError('Failed to generate external link');
      },
      complete: () => {
        // Ensures loader stops whether success or error occurs
        this.isGeneratingLink = false;
      },
    });
  }

  /**
   * Safe copy helper with fallback for non-HTTPS / HTTP environments
   */
  private copyToClipboard(text: string) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.toaster.showSuccess('External link copied to clipboard!');
        })
        .catch((err) => {
          console.error('Clipboard API error:', err);
          this.fallbackCopyTextToClipboard(text);
        });
    } else {
      // Fallback for non-secure HTTP connections
      this.fallbackCopyTextToClipboard(text);
    }
  }

  /**
   * Legacy execCommand fallback for plain HTTP IP access
   */
  private fallbackCopyTextToClipboard(text: string) {
    const textArea = document.createElement('textarea');
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        this.toaster.showSuccess('External link copied to clipboard!');
      } else {
        this.toaster.showError('Failed to copy external link.');
      }
    } catch (err) {
      console.error('Fallback copy error:', err);
      this.toaster.showError('Unable to copy link automatically.');
    } finally {
      document.body.removeChild(textArea);
    }
  }

  /**
   * Open Dialog & Fetch Available CVs
   */
  openBulkUploadDialog(): void {
    this.bulkUploadDialogVisible = true;
    this.fetchWalkinCVs();
  }

  /**
   * Reset state when dialog hides
   */
  resetBulkUploadState(): void {
    this.stopBatchPolling();
    this.currentBatchId = null;
    this.batchStatusData = null;
    this.batchProgressPercent = 0;
    this.selectedWalkinCVs = [];
  }

  // Polls every 3 seconds until all CVs are finished processing
  startPolling() {
    if (this.pollingSubscription) {
      return;
    }

    this.pollingSubscription = interval(5000)
      .pipe(
        switchMap(() =>
          this.commonService.get(
            `/jobpost/attached-cvs/?job_post=${this.jobId}`,
          ),
        ),
      )
      .subscribe({
        next: (res: any[]) => {
          this.updateCandidateProcessingStatus(res);
        },

        error: () => {
          this.stopPolling();
        },
      });
  }

  private updateCandidateProcessingStatus(apiData: any[]) {
    let stillProcessing = false;

    apiData.forEach((apiCandidate) => {
      const existing = this.candidateMap.get(apiCandidate.id);

      if (!existing) {
        return;
      }

      // Only update changed fields
      existing.processingStatus = apiCandidate.processing_status;
      existing.failureReason = apiCandidate.failure_reason || null;
      existing.failure =
        String(apiCandidate.processing_status || '').toLowerCase() === 'failed'
          ? this.failureInfo(apiCandidate.failure_reason)
          : null;
      if (apiCandidate.name) existing.name = apiCandidate.name;
      if (apiCandidate.emails) existing.email = apiCandidate.emails;

      if (
        ['pending', 'processing', 'in_progress'].includes(
          apiCandidate.processing_status?.toLowerCase(),
        )
      ) {
        stillProcessing = true;
      }
    });

    // Update current page only
    this.updatePaginatedCandidates();

    if (!stillProcessing) {
      this.stopPolling();

      // Final refresh once processing finishes
      this.getCandidates();
    }
  }

  stopPolling() {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();

      this.pollingSubscription = undefined;
    }
  }

  ngOnDestroy(): void {
    this.stopPolling();
    this.stopBatchPolling();
  }

  // ========================================================
  // WALK-IN CV TAB PROPERTIES & METHODS
  // ========================================================
  pendingWalkinCount: number = 0;

  // Call this inside your existing ngOnInit() or getJobDetails()
  loadWalkinTabDetails(): void {
    this.fetchWalkinCVs();
  }

  fetchWalkinCVs(): void {
    if (!this.jobId) return;
    this.loadingWalkinCVs = true;

    this.commonService
      .get(`/jobpost/walkin-cvs/?job_post=${this.jobId}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.walkinCVList = Array.isArray(res) ? res : res?.results || [];
          this.walkinMap.clear();

          this.walkinCVList.forEach((cv) => {
            cv.processing_status = 'Pending';

            this.walkinMap.set(cv.id, cv);
          });
          this.pendingWalkinCount = this.walkinCVList.length;
          this.loadingWalkinCVs = false;
        },
        error: () => {
          this.loadingWalkinCVs = false;
          this.pendingWalkinCount = 0;
        },
      });
  }

  walkinMap = new Map<number, any>();

  processSelectedCVs() {
    if (!this.selectedWalkinCVs.length || this.processingCVs || this.attachState === 'running') return;

    const selected = [...this.selectedWalkinCVs];
    this.processingCVs = true;

    // Show progress straight away — the rows flip to "Queued" and the banner appears.
    this.attachState = 'running';
    this.attachTotal = selected.length;
    this.attachDone = 0;
    this.attachFailed = 0;
    this.attachMessage = '';
    this.batchStatusData = null;
    this.batchProgressPercent = 0;
    const previousStatus = new Map<any, any>(selected.map((cv: any) => [cv, cv.processing_status]));
    selected.forEach((cv: any) => (cv.processing_status = 'pending'));

    // Extract array of selected Walk-in CV IDs
    const payload = {
      walkin_cv_ids: selected.map((cv: any) => cv.id),
    };

    this.commonService.post('/jobpost/attached-cvs/', payload).subscribe({
      next: (res: any) => {
        this.processingCVs = false;
        this.selectedWalkinCVs = [];

        this.toaster.showInfo(
          `Attaching ${selected.length} CV${selected.length === 1 ? '' : 's'}… ` +
            'They will appear in the Applied Candidates tab once processed.',
        );

        if (res?.batch_id) {
          this.startBatchStatusPolling(res.batch_id);
        } else {
          // No batch to track — the server finished (or queued) it in one go.
          this.finishAttach(selected.length, 0);
        }
      },
      error: (err: any) => {
        this.processingCVs = false;
        selected.forEach((cv: any) => (cv.processing_status = previousStatus.get(cv)));
        this.attachState = 'error';
        this.attachMessage = this.readAttachError(err);
        this.toaster.showError(this.attachMessage);
        this.fetchWalkinCVs();
      },
    });
  }

  /** Called once the whole batch has finished. */
  private finishAttach(done: number, failed: number): void {
    this.stopBatchPolling();
    this.attachState = 'done';
    this.attachDone = done;
    this.attachFailed = failed;
    this.batchProgressPercent = 100;

    if (done > 0 && failed === 0) {
      this.toaster.showSuccess(
        `${done} CV${done === 1 ? '' : 's'} attached. See the Applied Candidates tab.`,
      );
    } else if (done > 0) {
      this.toaster.showWarn(`${done} CV${done === 1 ? '' : 's'} attached, ${failed} failed.`);
    } else {
      this.toaster.showError('None of the selected CVs could be attached.');
    }

    // Refresh main candidate list & walk-in pool tab, and take the user to
    // the Applied Candidates tab so they can see the new rows straight away.
    this.getCandidates();
    this.fetchWalkinCVs();
    if (done > 0) this.activeTabIndex = 0;
  }

  /** "View Applied Candidates" on the banner. */
  viewAppliedCandidates(): void {
    this.activeTabIndex = 0;
    if (this.attachState !== 'running') this.dismissAttachBanner();
  }

  dismissAttachBanner(): void {
    this.attachState = 'idle';
    this.batchStatusData = null;
    this.batchProgressPercent = 0;
  }

  /** Processed so far (done + failed), for the banner text. */
  get attachProcessed(): number {
    return this.attachDone + this.attachFailed;
  }

  private readAttachError(err: any): string {
    const body = err?.error;
    if (typeof body === 'string' && body) return body;
    if (body?.message) return String(body.message);
    if (body?.detail) return String(body.detail);
    if (body?.error) return String(body.error);
    if (body && typeof body === 'object') {
      for (const key of Object.keys(body)) {
        const v = Array.isArray(body[key]) ? body[key][0] : body[key];
        if (typeof v === 'string' && v) return v;
      }
    }
    return 'Failed to attach walk-in CVs. Please try again.';
  }

  startBatchStatusPolling(batchId: string): void {
    this.currentBatchId = batchId;
    this.stopBatchPolling();

    this.checkBatchStatus(batchId);
    this.batchPollInterval = setInterval(() => {
      this.checkBatchStatus(batchId);
    }, 3000);
  }

  private checkBatchStatus(batchId: string): void {
    this.commonService
      .get(`/jobpost/attached-cvs/status/?batch_id=${batchId}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.batchStatusData = res;

          if (res.cvs) {
            res.cvs.forEach((item: any) => {
              const cv = this.walkinMap.get(item.id);

              if (cv) {
                cv.processing_status = item.processing_status;

                cv.name = item.name;

                cv.email = item.emails;
              }
            });
          }

          if (res?.total) this.attachTotal = res.total;
          this.attachDone = res?.done || 0;
          this.attachFailed = res?.failed || 0;

          // Calculate progress percentage
          if (res?.progress_percent !== undefined) {
            this.batchProgressPercent = res.progress_percent;
          } else if (res?.total && res?.total > 0) {
            const completedCount = (res.done || 0) + (res.failed || 0);
            this.batchProgressPercent = Math.round(
              (completedCount / res.total) * 100,
            );
          }

          const normalizedStatus = (res?.status || '').toUpperCase();
          const totalItems = res?.total || 0;
          const processedItems = (res?.done || 0) + (res?.failed || 0);

          // Terminal condition: stop polling when batch finishes or all items reach terminal state
          if (
            normalizedStatus === 'COMPLETED' ||
            normalizedStatus === 'FAILED' ||
            (totalItems > 0 && processedItems === totalItems)
          ) {
            const done =
              normalizedStatus === 'FAILED' && !res?.done ? 0 : res?.done ?? Math.max(totalItems - (res?.failed || 0), 0);
            this.finishAttach(done, res?.failed || 0);
          }
        },
        error: () => {
          // Lost track of the batch — it may still finish on the server.
          this.stopBatchPolling();
          this.attachState = 'error';
          this.attachMessage =
            "Couldn't check the progress. The CVs may still be processing — refresh Applied Candidates in a moment.";
          this.getCandidates();
          this.fetchWalkinCVs();
        },
      });
  }

  stopBatchPolling(): void {
    if (this.batchPollInterval) {
      clearInterval(this.batchPollInterval);
      this.batchPollInterval = null;
    }
  }

  onTabChange(event: any): void {
    // Index 1 corresponds to the Walk-in CV Pool tab
    if (event.index === 1) {
      this.fetchWalkinCVs();
    }
  }

  onFilesSelected(event: any): void {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;

    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    }
    if (this.jobId) {
      formData.append('job_post', this.jobId.toString());
    }

    this.loadingWalkinCVs = true;

    this.commonService
      .post('/jobpost/walkin-cvs/upload/', formData)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.toaster?.showSuccess('Files uploaded successfully!');
          this.fetchWalkinCVs(); // Refresh candidate list after upload
        },
        error: (err: any) => {
          this.loadingWalkinCVs = false;
          this.toaster?.showError(
            err?.error?.message || 'Failed to upload files.',
          );
        },
      });
  }

  // ===================================================================
  // POST EXAM STATUS ("Manage Onboarding") DIALOG — presentation state
  //
  // Everything in this block exists for the redesigned dialog's layout
  // only. It does not touch `onboardingForm`, the payloads built in
  // nextStep()/submitOnboarding(), or any endpoint — the saved fields are
  // still exactly the twelve controls declared in the form group.
  //
  // The blocks these back (offer-letter template, document upload and
  // preview, work model, reporting manager, document checklist, IT
  // provisioning) are marked "Preview" in the UI because there are no
  // fields behind them yet. When the backend gains them, move each one
  // onto a real form control and drop its `pes-preview` class.
  // ===================================================================

  /**
   * Dialog width per step. Step 2 carries the offer-letter preview pane
   * beside the form, so it needs the extra room; the other two read
   * better narrow. Held as fixed objects rather than built in the getter
   * so the `[style]` binding keeps a stable identity between change
   * detection runs.
   */
  private readonly onboardingDialogStyles: { [step: number]: any } = {
    0: { width: '94vw', 'max-width': '680px' },
    // Step 2 no longer carries the letter preview beside the form, so it
    // no longer needs the extra 300px it used to.
    1: { width: '94vw', 'max-width': '720px' },
    2: { width: '95vw', 'max-width': '860px' },
    3: { width: '94vw', 'max-width': '760px' },
  };

  get onboardingDialogStyle(): any {
    return (
      this.onboardingDialogStyles[this.currentOnboardingStep] ||
      this.onboardingDialogStyles[0]
    );
  }

  /** Role line under the candidate's name in the dialog banner. */
  get onboardingRoleLabel(): string {
    return (
      this.jobDetails?.job_title ||
      this.jobDetails?.title ||
      this.jobDetails?.job_role ||
      'Candidate'
    );
  }

  /**
   * "Online Exam: 94% (Cleared)" chip. Built from the score already on
   * the candidate row; returns '' when there is nothing to show, and the
   * chip is then omitted rather than rendered empty.
   */
  get onboardingExamSummary(): string {
    const candidate = this.selectedCandidate;
    if (!candidate) return '';

    const raw = candidate.totalScore ?? candidate.mcqScore;
    const score = typeof raw === 'number' ? raw : Number(raw);
    if (raw === null || raw === undefined || raw === '-' || isNaN(score)) {
      return '';
    }

    const status = (candidate.mcqStatus || candidate.examStatus?.status || '')
      .toString()
      .trim();

    return status
      ? `Online Exam: ${score}% (${status})`
      : `Online Exam: ${score}%`;
  }

  /** Live counter under the welcome-instructions textarea. */
  get additionalInfoLength(): number {
    const value = this.onboardingForm?.get('additional_info')?.value;
    return typeof value === 'string' ? value.length : 0;
  }

  /** Placeholder name for the offer document rows. */
  get onboardingOfferFileName(): string {
    const name = (this.selectedCandidate?.name || 'Candidate')
      .toString()
      .trim()
      .replace(/\s+/g, '_');
    return `${name}_Offer_Letter.pdf`;
  }

  trackByIndex(index: number): number {
    return index;
  }

  /**
   * Step navigation from the stepper track. Only backwards — going
   * forward has to run through nextStep(), which validates and saves the
   * step being left.
   */
  goToOnboardingStep(index: number): void {
    if (index < 0 || index >= this.onboardingSteps.length) return;
    if (index >= this.currentOnboardingStep) return;

    this.currentOnboardingStep = index;

    if (index === this.STEP_REVIEW) {
      this.loadOfferPreview();
    }
  }

  // ---------------- design-only option lists (see note above) ----------------

  // ===================================================================
  // OFFER LETTER TEMPLATE
  //
  // An organisation-level setting, not a per-candidate one: uploaded
  // once and reused for everybody, which is why the dialog shows only a
  // one-line summary of it.
  //
  //   GET  /user/masters/organizations/{id}/                       read
  //   POST /user/masters/organizations/{id}/upload-offer-template/  set
  //
  // The org id comes from the login payload (clientLogin stores
  // `organization_id`), so nothing has to be passed into the dialog.
  // ===================================================================

  /**
   * Two templates are on offer, the same pair as before the endpoints
   * were wired:
   *
   *   standard      the platform's own letter. Always available, needs no
   *                 upload, and is what the backend falls back to when no
   *                 file is attached to the send.
   *   organisation  a letter this org uploaded once, reused for everybody
   *                 afterwards.
   *
   * A file attached for one candidate overrides whichever is selected,
   * for that send only.
   */
  templateChoice: 'standard' | 'organisation' = 'standard';

  /** The org's saved template, re-hosted on the configured base URL. */
  orgTemplateUrl = '';
  orgTemplateName = '';
  loadingOrgTemplate = false;
  uploadingTemplate = false;

  /** The upload panel under the summary row. */
  templatePickerOpen = false;

  get hasOrgTemplate(): boolean {
    return !!this.orgTemplateUrl;
  }

  private get organizationId(): string {
    try {
      const id = (localStorage.getItem('organization_id') || '').trim();
      return id && id !== 'null' && id !== 'undefined' ? id : '';
    } catch {
      return '';
    }
  }

  /**
   * Media paths arrive absolute from the GET and relative from the
   * upload, and the absolute one carries whichever host the API happened
   * to answer on — not necessarily the host this app talks to. So both
   * are reduced to a path and re-hosted on the configured base URL.
   */
  private mediaUrl(value: string): string {
    const raw = (value || '').toString().trim();
    if (!raw) return '';

    const path = raw.replace(/^https?:\/\/[^/]+/i, '');
    const base = (environment._url || '').replace(/\/+$/, '');

    return path.startsWith('/') ? `${base}${path}` : `${base}/${path}`;
  }

  private fileNameFrom(value: string): string {
    const path = (value || '').toString().split('?')[0];
    const name = path.substring(path.lastIndexOf('/') + 1);
    return decodeURIComponent(name || 'offer_template.pdf');
  }

  loadOrgTemplate(): void {
    const orgId = this.organizationId;

    if (!orgId) {
      this.applyOrgTemplate('');
      return;
    }

    this.loadingOrgTemplate = true;

    this.commonService.get(`/user/masters/organizations/${orgId}/`).subscribe({
      next: (res: any) => {
        this.applyOrgTemplate(res?.offer_letter_template);
        this.loadingOrgTemplate = false;
      },
      error: () => {
        // No template is the normal first-run state, so this stays quiet:
        // the dialog shows its "no template yet" block either way.
        this.applyOrgTemplate('');
        this.loadingOrgTemplate = false;
      },
    });
  }

  private applyOrgTemplate(value: any): void {
    const raw = (value || '').toString().trim();
    this.orgTemplateUrl = raw ? this.mediaUrl(raw) : '';
    this.orgTemplateName = raw ? this.fileNameFrom(raw) : '';

    // An org that has uploaded a letter means to use it, so it wins the
    // default. Without one there is nothing to select but the standard.
    this.templateChoice = this.orgTemplateUrl ? 'organisation' : 'standard';
  }

  selectTemplate(choice: 'standard' | 'organisation'): void {
    if (choice === 'organisation' && !this.orgTemplateUrl) {
      this.toaster.showInfo('Upload your organisation template first.');
      return;
    }

    this.templateChoice = choice;
    this.templatePickerOpen = false;
  }

  get usingOrgTemplate(): boolean {
    return this.templateChoice === 'organisation' && !!this.orgTemplateUrl;
  }

  /** Summary-row label for whichever template is selected. */
  get activeTemplateLabel(): string {
    return this.usingOrgTemplate
      ? this.orgTemplateName
      : 'Standard Offer Template';
  }

  get activeTemplateHint(): string {
    return this.usingOrgTemplate
      ? "Your organisation's letter, used for every candidate"
      : 'Provided by the platform — no upload needed';
  }

  /** Only an uploaded file can be opened; the standard one lives server-side. */
  get canViewActiveTemplate(): boolean {
    return this.usingOrgTemplate;
  }

  /**
   * Uploading replaces the organisation's default immediately — that is
   * the point of it. Every candidate opened afterwards already has it.
   */
  onOfferTemplateSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    if (!file) return;

    input.value = '';

    if (!/\.(docx?|pdf)$/i.test(file.name)) {
      this.toaster.showError('Upload a .docx or .pdf file.');
      return;
    }

    if (file.size > 15 * 1024 * 1024) {
      this.toaster.showError('That file is over the 15MB limit.');
      return;
    }

    const orgId = this.organizationId;
    if (!orgId) {
      this.toaster.showError(
        'No organisation on this account, so the template cannot be saved.',
      );
      return;
    }

    const formData = new FormData();
    formData.append('offer_letter_template', file, file.name);

    this.uploadingTemplate = true;

    this.commonService
      .postFormData(
        `/user/masters/organizations/${orgId}/upload-offer-template/`,
        formData,
      )
      .subscribe({
        next: (res: any) => {
          this.applyOrgTemplate(res?.offer_letter_template);
          this.uploadingTemplate = false;
          this.templatePickerOpen = false;

          this.toaster.showSuccess(
            'Saved as your default — every candidate from now on uses this template.',
          );
        },
        error: (err: any) => {
          this.uploadingTemplate = false;
          this.toaster.showError(
            err?.error?.detail ||
              err?.error?.message ||
              'Unable to upload the offer template.',
          );
        },
      });
  }

  /** Opens the stored template in a new browser tab. */
  viewOfferTemplate(): void {
    if (!this.orgTemplateUrl) {
      this.toaster.showInfo('No offer template uploaded yet.');
      return;
    }
    this.openInNewTab(this.orgTemplateUrl);
  }

  private openInNewTab(url: string): void {
    const opened = window.open(url, '_blank');
    if (!opened) {
      this.toaster.showWarn(
        'Your browser blocked the new tab — allow pop-ups for this site.',
      );
    }
  }

  // ===================================================================
  // PER-CANDIDATE OFFER LETTER
  //
  // Optional. The organisation template is what normally goes out; this
  // is the override for a candidate whose letter differs, and it is
  // attached to that one send only.
  // ===================================================================

  candidateLetterFile: File | null = null;

  onCandidateLetterSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    if (!file) return;

    input.value = '';

    if (!/\.(docx?|pdf)$/i.test(file.name)) {
      this.toaster.showError('Attach a .docx or .pdf file.');
      return;
    }

    if (file.size > 15 * 1024 * 1024) {
      this.toaster.showError('That file is over the 15MB limit.');
      return;
    }

    this.candidateLetterFile = file;
    this.toaster.showInfo(`${file.name} will be sent instead of the template.`);
  }

  clearCandidateLetter(): void {
    this.candidateLetterFile = null;
  }

  // ===================================================================
  // REVIEW & SEND
  //
  // The candidate never sees "the template" — they see an email with a
  // letter attached, so that is what this step previews. Both the body
  // and the send come from the backend:
  //
  //   POST /jobpost/post-exam-statuses/{id}/preview-offer-details/
  //        { offer_rolled_out_date, offer_amount, offer_details }
  //        -> { to_email, subject, html_body }
  //
  //   POST /jobpost/post-exam-statuses/{id}/send-offer-details/
  //        multipart: the same three fields + offer_letter_file
  //        -> the updated post-exam-status record
  //
  // Nothing here is composed client-side, so what is previewed is what
  // the mailer actually sends.
  // ===================================================================

  offerPreviewTo = '';
  offerPreviewSubject = '';
  offerPreviewHtml: SafeHtml | null = null;

  loadingPreview = false;
  previewError = '';

  /** true once send-offer-details has succeeded for this candidate. */
  offerSent = false;
  isSendingOffer = false;

  /** Path returned by the send, so the sent letter can be reopened. */
  sentLetterUrl = '';

  private previewRequest?: Subscription;

  /**
   * Called on arrival at the Review step. The values are read from the
   * form, not the saved record, so an edit made on Step 2 and saved by
   * its Next shows up here immediately.
   */
  loadOfferPreview(): void {
    if (!this.currentExamId) {
      this.previewError =
        'Save the interview and offer details first — the preview is built from the saved record.';
      return;
    }

    const form = this.onboardingForm.value;

    this.loadingPreview = true;
    this.previewError = '';

    const payload = {
      offer_rolled_out_date: this.formatDate(form.offer_rolled_out_date),
      offer_amount: form.offer_amount,
      offer_details: form.offer_details,
    };

    this.previewRequest?.unsubscribe();
    this.previewRequest = this.commonService
      .post(
        `/jobpost/post-exam-statuses/${this.currentExamId}/preview-offer-details/`,
        payload,
      )
      .subscribe({
        next: (res: any) => {
          this.offerPreviewTo = res?.to_email || '';
          this.offerPreviewSubject = res?.subject || '';

          // This body is our own backend's template and carries inline
          // styles Angular's sanitiser would strip, so it is trusted
          // explicitly rather than rendered stripped and misleading.
          this.offerPreviewHtml = res?.html_body
            ? this.sanitizer.bypassSecurityTrustHtml(res.html_body)
            : null;

          this.loadingPreview = false;
        },
        error: (err: any) => {
          this.loadingPreview = false;
          this.offerPreviewHtml = null;
          this.previewError =
            err?.error?.detail ||
            err?.error?.message ||
            'Could not build the offer preview.';
        },
      });
  }

  retryPreview(): void {
    this.loadOfferPreview();
  }

  /** What the send will attach, for the chip on the Review step. */
  get outgoingLetterName(): string {
    if (this.candidateLetterFile) return this.candidateLetterFile.name;
    if (this.usingOrgTemplate) return this.orgTemplateName;
    return 'Standard Offer Template';
  }

  get outgoingLetterSource(): string {
    if (this.candidateLetterFile) return 'Uploaded for this candidate';
    if (this.usingOrgTemplate) return "Your organisation's template";
    return 'Platform template, applied when the offer is sent';
  }

  /** The standard template has no file here to open — the server holds it. */
  get hasOutgoingLetter(): boolean {
    return !!(
      this.candidateLetterFile ||
      this.sentLetterUrl ||
      this.usingOrgTemplate
    );
  }

  /** Opens whichever letter is going out, or already went out. */
  viewOutgoingLetter(): void {
    if (this.candidateLetterFile) {
      const url = URL.createObjectURL(this.candidateLetterFile);
      this.openInNewTab(url);
      setTimeout(() => URL.revokeObjectURL(url), 60000);
      return;
    }

    const url = this.sentLetterUrl || this.orgTemplateUrl;
    if (!url) {
      this.toaster.showInfo('No offer letter to preview yet.');
      return;
    }

    this.openInNewTab(url);
  }

  // ------------------------------ sending ------------------------------

  sendOffer(): void {
    if (this.isSendingOffer) return;

    if (!this.currentExamId) {
      this.toaster.showError(
        'Save the interview and offer details before sending.',
      );
      return;
    }

    this.isSendingOffer = true;

    // A file uploaded for this candidate wins; otherwise the org template
    // is read back and attached, which is what makes "upload once" hold
    // for every candidate after the first.
    if (this.candidateLetterFile) {
      this.postSendOffer(
        this.candidateLetterFile,
        this.candidateLetterFile.name,
      );
      return;
    }

    // The standard template is the backend's own, so nothing is attached
    // and the server applies it. Only an uploaded organisation letter has
    // a file for the client to send.
    if (!this.usingOrgTemplate) {
      this.postSendOffer(null, '');
      return;
    }

    const base = (environment._url || '').replace(/\/+$/, '');
    const path = this.orgTemplateUrl.startsWith(base)
      ? this.orgTemplateUrl.slice(base.length)
      : this.orgTemplateUrl;

    this.commonService.getBlob(path).subscribe({
      next: (blob: Blob) => {
        this.postSendOffer(blob, this.orgTemplateName || 'offer_letter.pdf');
      },
      error: () => {
        // Could not read the template back. Still send the details, and
        // say why the attachment is missing rather than failing quietly.
        this.toaster.showWarn(
          'Could not attach the organisation template; sending the offer details without it.',
        );
        this.postSendOffer(null, '');
      },
    });
  }

  private postSendOffer(file: Blob | null, fileName: string): void {
    const form = this.onboardingForm.value;

    const formData = new FormData();
    formData.append(
      'offer_rolled_out_date',
      this.formatDate(form.offer_rolled_out_date) || '',
    );
    formData.append('offer_amount', `${form.offer_amount ?? ''}`);
    formData.append('offer_details', `${form.offer_details ?? ''}`);

    if (file) {
      formData.append('offer_letter_file', file, fileName);
    }

    this.commonService
      .postFormData(
        `/jobpost/post-exam-statuses/${this.currentExamId}/send-offer-details/`,
        formData,
      )
      .subscribe({
        next: (res: any) => {
          this.isSendingOffer = false;
          this.offerSent = true;

          if (res?.offer_letter_file) {
            this.sentLetterUrl = this.mediaUrl(res.offer_letter_file);
          }

          // The response is the whole record, so the acceptance flag is
          // taken from it rather than left at whatever the form held.
          if (typeof res?.is_accepted === 'boolean') {
            this.onboardingForm.patchValue(
              { is_accepted: res.is_accepted },
              { emitEvent: false },
            );
          }

          this.toaster.showSuccess(
            `Offer sent to ${
              this.offerPreviewTo || this.selectedCandidate?.name || 'the candidate'
            }.`,
          );
        },
        error: (err: any) => {
          this.isSendingOffer = false;
          this.toaster.showError(
            err?.error?.detail ||
              err?.error?.message ||
              'Unable to send the offer.',
          );
        },
      });
  }

  // --------------------------- acceptance gate ---------------------------

  /**
   * Onboarding cannot begin until the candidate has accepted, so Step 4
   * stays inert until this is set. The recruiter sets it on the Review
   * step once the confirmation call has happened — the offer mail itself
   * tells the candidate to ring HR.
   */
  get offerAccepted(): boolean {
    return !!this.onboardingForm?.get('is_accepted')?.value;
  }

  get onboardingLocked(): boolean {
    return !this.offerAccepted || this.docsNotVerified;
  }

  /** PATCH for the acceptance tick is in flight. */
  savingAcceptance = false;

  /** Acceptance can only be recorded once the offer has gone out
   *  (or un-ticked if it was already recorded earlier). */
  get canRecordAcceptance(): boolean {
    return (this.offerSent || this.offerAccepted) && !!this.currentExamId;
  }

  /**
   * Review step checkbox. Saves straight away (PATCH is_accepted) so the
   * value can't be lost by Continue / closing the dialog, and Step 4 sees
   * the saved state.
   */
  onAcceptanceToggle(checked: boolean): void {
    if (!this.canRecordAcceptance) {
      this.toaster.showWarn('Send the offer first, then record the acceptance.');
      return;
    }

    const previous = this.offerAccepted;
    this.onboardingForm.patchValue({ is_accepted: checked }, { emitEvent: false });
    this.savingAcceptance = true;

    this.commonService
      .patch(`/jobpost/post-exam-statuses/${this.currentExamId}/`, {
        is_accepted: checked,
        attached_cv: this.selectedCandidate?.id,
      })
      .subscribe({
        next: () => {
          this.savingAcceptance = false;
          this.onboardingChanged = true;
          if (this.selectedCandidate?.examStatus) {
            this.selectedCandidate.examStatus.is_accepted = checked;
          }
          this.toaster.showSuccess(
            checked
              ? 'Offer acceptance saved. Onboarding is now unlocked.'
              : 'Offer acceptance removed.',
          );
        },
        error: (err) => {
          this.savingAcceptance = false;
          this.onboardingForm.patchValue({ is_accepted: previous }, { emitEvent: false });
          this.handleError(err);
        },
      });
  }


  
  
}
